import React from 'react';
import MuiSlider from '@mui/material/Slider';
import {getCurrencyString} from '../../../utils/currencyFormatter';
import {convertDomainToRange, GoalFormValues} from './utils';

const VAL_0 = 0;
const VAL_1K = 1000;
const VAL_5K = 5000;
const VAL_10K = 10000;
const VAL_50K = 50000;
const VAL_100K = 100000;
const VAL_500K = 500000;
const VAL_1M = 1000000;
const VAL_5M = 5000000;
const VAL_10M = 10000000;

export interface ValueLabel {
  value: number;
  label: string;
}

const LABEL_DICT = {
  VAL_0: {
    value: 0,
    label: getCurrencyString(VAL_0, {isAbbreviated: false, decimalPlaces: 0}),
  },
  VAL_1K: {
    value: 1,
    label: getCurrencyString(VAL_1K, {isAbbreviated: true}),
  },
  VAL_5K: {
    value: 2,
    label: getCurrencyString(VAL_5K, {isAbbreviated: true}),
  },
  VAL_10K: {
    value: 3,
    label: getCurrencyString(VAL_10K, {isAbbreviated: true}),
  },
  VAL_50K: {
    value: 4,
    label: getCurrencyString(VAL_50K, {isAbbreviated: true}),
  },
  VAL_100K: {
    value: 5,
    label: getCurrencyString(VAL_100K, {isAbbreviated: true}),
  },
  VAL_500K: {
    value: 6,
    label: getCurrencyString(VAL_500K, {isAbbreviated: true}),
  },
  VAL_1M: {
    value: 7,
    label: getCurrencyString(VAL_1M, {isAbbreviated: true}),
  },
  VAL_5M: {
    value: 8,
    label: getCurrencyString(VAL_5M, {isAbbreviated: true}),
  },
  VAL_10M: {
    value: 9,
    label: getCurrencyString(VAL_10M, {isAbbreviated: true}),
  },
};

export const convertValueToScale = (v: number): number => {
  if (v === VAL_0) {
    return LABEL_DICT.VAL_0.value;
  }
  if (v < VAL_1K) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_1K,
      domainMin: VAL_0,
      rangeMax: LABEL_DICT.VAL_1K.value,
      rangeMin: LABEL_DICT.VAL_0.value,
    });
  }
  if (v === VAL_1K) {
    return LABEL_DICT.VAL_1K.value;
  }
  if (v < VAL_5K) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_5K,
      domainMin: VAL_1K,
      rangeMax: LABEL_DICT.VAL_5K.value,
      rangeMin: LABEL_DICT.VAL_1K.value,
    });
  }
  if (v === VAL_5K) {
    return LABEL_DICT.VAL_5K.value;
  }
  if (v < VAL_10K) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_10K,
      domainMin: VAL_5K,
      rangeMax: LABEL_DICT.VAL_10K.value,
      rangeMin: LABEL_DICT.VAL_5K.value,
    });
  }
  if (v === VAL_10K) {
    return LABEL_DICT.VAL_10K.value;
  }
  if (v < VAL_50K) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_50K,
      domainMin: VAL_10K,
      rangeMax: LABEL_DICT.VAL_50K.value,
      rangeMin: LABEL_DICT.VAL_10K.value,
    });
  }
  if (v === VAL_50K) {
    return LABEL_DICT.VAL_50K.value;
  }
  if (v < VAL_100K) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_100K,
      domainMin: VAL_50K,
      rangeMax: LABEL_DICT.VAL_100K.value,
      rangeMin: LABEL_DICT.VAL_50K.value,
    });
  }
  if (v === VAL_100K) {
    return LABEL_DICT.VAL_100K.value;
  }
  if (v < VAL_500K) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_500K,
      domainMin: VAL_100K,
      rangeMax: LABEL_DICT.VAL_500K.value,
      rangeMin: LABEL_DICT.VAL_100K.value,
    });
  }
  if (v === VAL_500K) {
    return LABEL_DICT.VAL_500K.value;
  }
  if (v < VAL_1M) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_1M,
      domainMin: VAL_500K,
      rangeMax: LABEL_DICT.VAL_1M.value,
      rangeMin: LABEL_DICT.VAL_500K.value,
    });
  }
  if (v === VAL_1M) {
    return LABEL_DICT.VAL_1M.value;
  }
  if (v < VAL_5M) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_5M,
      domainMin: VAL_1M,
      rangeMax: LABEL_DICT.VAL_5M.value,
      rangeMin: LABEL_DICT.VAL_1M.value,
    });
  }
  if (v === VAL_5M) {
    return LABEL_DICT.VAL_5M.value;
  }
  if (v < VAL_10M) {
    return convertDomainToRange({
      value: v,
      domainMax: VAL_10M,
      domainMin: VAL_5M,
      rangeMax: LABEL_DICT.VAL_10M.value,
      rangeMin: LABEL_DICT.VAL_5M.value,
    });
  }
  return LABEL_DICT.VAL_10M.value;
};

export const convertScaleToValue = (s: number): number => {
  switch (s) {
    case LABEL_DICT.VAL_0.value:
      return VAL_0;
    case LABEL_DICT.VAL_1K.value:
      return VAL_1K;
    case LABEL_DICT.VAL_5K.value:
      return VAL_5K;
    case LABEL_DICT.VAL_10K.value:
      return VAL_10K;
    case LABEL_DICT.VAL_50K.value:
      return VAL_50K;
    case LABEL_DICT.VAL_100K.value:
      return VAL_100K;
    case LABEL_DICT.VAL_500K.value:
      return VAL_500K;
    case LABEL_DICT.VAL_1M.value:
      return VAL_1M;
    case LABEL_DICT.VAL_5M.value:
      return VAL_5M;
    default:
      return VAL_10M;
  }
};

export const CAPITAL_MARKS: ValueLabel[] = Object.values(LABEL_DICT);
export const INCOME_MARKS: ValueLabel[] = CAPITAL_MARKS.slice(
  0,
  CAPITAL_MARKS.length - 1
);

export interface LogSliderProps {
  marks?: ValueLabel[];
  onChange?: (v: number) => void;
  values: GoalFormValues;
  field: string;
  disabled?: boolean;
}

export function LogSlider(props: LogSliderProps) {
  const {marks, onChange, values, field, ...logProps} = props;

  const scaleLog = (v: number) =>
    parseFloat(marks?.find((o) => o.value === v)?.label || '');
  const max = marks?.length ? marks[marks.length - 1].value : undefined;
  return (
    <MuiSlider
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...logProps}
      marks={marks}
      step={1}
      min={marks?.[0]?.value}
      max={max}
      scale={scaleLog}
      value={convertValueToScale(Number((values as any)[field]))}
      onChange={(e, v) => {
        onChange?.(convertScaleToValue(v as number));
      }}
    />
  );
}
